import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import { CommonStyles } from './components/shared/BaseProps.es.js';
import { B as BREAK_POINTS } from './constant-f622fb0e.js';
import styled from '@emotion/styled';
import { unitParse } from './utils.es.js';

const Wrapper = styled.div `
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${BREAK_POINTS.xl}) {
    max-width: ${(props) => (props.fluid ? '100%' : unitParse(props.maxWidth))};
  }
  ${CommonStyles}
`;
const Container = React.forwardRef((props, ref) => {
    const { children, fluid = false, maxWidth = 1232 } = props, others = __rest(props, ["children", "fluid", "maxWidth"]);
    return (jsx(Wrapper, Object.assign({ maxWidth: maxWidth, fluid: fluid, ref: ref }, others, { children: children })));
});
Container.displayName = 'Container';

export { Container as C };
